// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// components
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { LockScreenComponent } from './lock-screen/lock-screen.component';
import { PasswordDialogComponent } from './password-dialog/password-dialog.component';
import { DataDialogComponent } from './data-dialog/data-dialog.component';
import { MaskComponent } from './mask/mask.component';
import { MyDTComponent } from './my-dt/my-dt.component';
import { MyDTPaginationComponent } from 'app/shared/components/my-dt/my-dt-pagination/my-dt-pagination.component';

// directives
import { FocusDirective } from './directives/focus.directive';
import { MyDTHeaderDirective } from 'app/shared/components/my-dt/my-dt-header.directive';
import { MyDTHeaderOptionsDirective } from 'app/shared/components/my-dt/my-dt-header-options.directive';
import { MyDTFooterDirective } from 'app/shared/components/my-dt/my-dt-footer.directive';
import { MyDTRowDirective } from 'app/shared/components/my-dt/my-dt-row.directive';
import { MyDTColumnDirective } from 'app/shared/components/my-dt/my-dt-column.directive';

// modules
import { MaterialModule } from '../material/material.module';

// services
import { DialogsService } from '../services/dialog/dialog.service';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { AllowPopupDialogComponent } from './allow-popup-dialog/allow-popup-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    MaterialModule,
    TranslateModule,
    PipesModule,
    FormsModule
  ],
  exports: [
    ConfirmDialogComponent,
    LockScreenComponent,
    ErrorDialogComponent,
    PasswordDialogComponent,
    DataDialogComponent,
    VideoDialogComponent,
    AllowPopupDialogComponent,
    MyDTComponent, MyDTHeaderDirective, MyDTHeaderOptionsDirective, MyDTFooterDirective, MyDTRowDirective, MyDTColumnDirective,
    FocusDirective,
    MaskComponent,
    MyDTPaginationComponent
  ],
  declarations: [
    ConfirmDialogComponent,
    LockScreenComponent,
    ErrorDialogComponent,
    PasswordDialogComponent,
    DataDialogComponent,
    MyDTComponent, MyDTHeaderDirective, MyDTHeaderOptionsDirective, MyDTFooterDirective, MyDTRowDirective, MyDTColumnDirective,
    FocusDirective,
    MaskComponent,
    MyDTPaginationComponent,
    VideoDialogComponent,
    AllowPopupDialogComponent
  ],
  providers: [
    DialogsService
  ],
  entryComponents: [
    ConfirmDialogComponent,
    LockScreenComponent,
    PasswordDialogComponent,
    ErrorDialogComponent,
    DataDialogComponent,
    VideoDialogComponent,
    AllowPopupDialogComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/components.module.ts